import { Component, OnInit ,Input } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile } from 'ng-zorro-antd/upload';

@Component({
  selector: 'app-ui-bank-account-details',
  templateUrl: './ui-bank-account-details.component.html',
  styleUrls: ['./ui-bank-account-details.component.scss']
})
export class UiBankAccountDetailsComponent implements OnInit {

  @Input() forWhom = "Nominee";

  constructor(
      private message: NzMessageService,
  ) { }

  ngOnInit() {
    this.setDataToBeVerifiedByOCR();
  }

  /* Bank Details */
  bank:any = {};
  fakeValidationStatus:any = null;

  fetchFromIFSC(wait) {
    let fakeWaitMs = wait || 1200;
    this.bank = {};
    this.message.loading('Fetching Bank Details ...', { nzDuration: fakeWaitMs });
    setTimeout(()=>{
      this.bank = {
        bankName: "ICICI BANK LTD.",
        branchName: "MUMBAI - FORT",
        micr: "400229016",
        city: "MUMBAI",
        address: "NAVSARI BUILDING, 240, D.N.ROAD, FORT, MUMBAI. 400001"
      }
    }, fakeWaitMs);
  }

  /* Bank CHEQUE Upload */
  showUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: true,
    hidePreviewIconInNonImage: true
  };
  fileList = [ {
    uid: 1,
    name: 'xxx.png',
    status: 'done',
    url: "https://bse2nse.com/images/cancelled_cheque.png"
  }];
  previewImage: string | undefined = '';
  previewVisible = false;
  handlePreview = (file: NzUploadFile) => {
    this.previewImage = file.url || file.thumbUrl;
    this.previewVisible = true;
  };

  /* Bank Search Modal */
  modSearchBank: boolean = false;
  dataSet = [1,2,3]; // Dummy
  selectedBranch:any = ''; // Branch selected from the table listing





  /* DUMMY Models */
  bankAccount:string = "40078977300";
  accountHolderName: string = "Liam Hemsworth";

  /* If any of the inputs that affect OCR component has changed, we need to reset it */
  OCRReady = true;
  OCRInputModelsHaveChanged() {
    this.OCRReady = false;
    this.setDataToBeVerifiedByOCR();
    setTimeout(()=>{this.OCRReady = true},200);
  }

  /* OCR */
  OCRfileImage: string = 'https://bse2nse.com/images/cancelled_cheque.png'; /* Dummy Default for DEMO */
  handleFileUploadChange(e:any) {
    console.log("handleFileUploadChange",e.type);
    switch (e.type) { /* e.type：start, progress, success, removed */
      case 'removed':
        this.OCRInputModelsHaveChanged();
        break;
      case 'error':
      case 'success':
        this.setDataToBeVerifiedByOCR();
        this.OCRfileImage = e.file.url || e.file.thumbUrl;
        break;
    }
  }
  OCRverificationData:Array<any> = [];
  setDataToBeVerifiedByOCR() {
    this.OCRverificationData = [
      /* key: user-friendly name for item; value: the value to be OCR'd; status: current status of verification */
      {key: 'Bank Account Number', value: this.bankAccount||'N.A', status: 'Pending'},
      {key: 'Account Holder Name', value: this.accountHolderName||'N.A', status:'Pending'}
    ]
  }


}
